// extracted by mini-css-extract-plugin
export default {"header":"Table_header__ZZACV","link":"Table_link__a5ftG","active":"Table_active__BHClj","inactive":"Table_inactive__rsgK+","td":"Table_td__Zu7xP","search":"Table_search__JQAyG"};